<template>
    <div class="fa-pie-chart">
        <apexchart
            type="donut"
            :height="height"
            :options="chartOptions"
            :series="series"
        />
        <div class="chart-label" v-if="showLabel">{{ label }}</div>
    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';

export default {
    components: {
        apexchart: VueApexCharts,
    },
    props: {
        favorable: {
            type: Number,
            default: 0
        },
        neutral: {
            type: Number,
            default: 0
        },
        unfavorable: {
            type: Number,
            default: 0
        },
        label: {
            type: String,
            default: ''
        },
        showLabel: {
            type: Boolean,
            default: true
        },
        height: {
            type: [Number, String],
            default: 160
        },
        showLegend: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        series() {
            return [
                Math.round(this.favorable),
                Math.round(this.neutral),
                Math.round(this.unfavorable)
            ];
        },
        chartOptions() {
            return {
                chart: {
                    type: 'donut',
                    animations: {
                        enabled: true,
                        easing: 'easeinout',
                        speed: 800,
                    },
                },
                labels: ['Favorable', 'Neutral', 'Unfavorable'],
                colors: ['#4caf50', '#9e9e9e', '#f44336'],
                plotOptions: {
                    pie: {
                        donut: {
                            size: '65%',
                            labels: {
                                show: true,
                                name: {
                                    show: true,
                                    fontSize: '12px',
                                    fontWeight: 600,
                                    color: '#373d3f',
                                    offsetY: -5
                                },
                                value: {
                                    show: true,
                                    fontSize: '16px',
                                    fontWeight: 700,
                                    color: '#373d3f',
                                    offsetY: 5,
                                    formatter: function (val) {
                                        return Math.round(val) + '%';
                                    }
                                },
                                total: {
                                    show: true,
                                    label: 'Favorable',
                                    fontSize: '11px',
                                    fontWeight: 400,
                                    color: '#9e9e9e',
                                    formatter: (w) => {
                                        return Math.round(w.globals.series[0]) + '%';
                                    }
                                }
                            }
                        }
                    }
                },
                dataLabels: {
                    enabled: false
                },
                legend: {
                    show: this.showLegend,
                    position: 'bottom',
                    fontSize: '12px',
                    markers: {
                        width: 10,
                        height: 10,
                        radius: 2
                    }
                },
                stroke: {
                    width: 2,
                    colors: ['#fff']
                },
                tooltip: {
                    enabled: true,
                    y: {
                        formatter: function (val) {
                            return Math.round(val) + '%';
                        }
                    }
                },
                states: {
                    hover: {
                        filter: {
                            type: 'darken',
                            value: 0.9
                        }
                    },
                    active: {
                        filter: {
                            type: 'none'
                        }
                    }
                },
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            height: 140
                        }
                    }
                }]
            };
        }
    }
};
</script>

<style scoped>
.fa-pie-chart {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.chart-label {
    margin-top: 8px;
    font-size: 12px;
    font-weight: 600;
    color: #666;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}
</style>
